/*eslint-disable */
const $ = window.jQuery = require('jquery');

import {
  bus
} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'new-bucket-folder',
  components: {},
  props: [],
  data () {
    return {
      submitted:false,
      name:'New Folder'
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    getBucketListAgainMethod(){
      this.$store.dispatch('getBucketListOfAwerackFun').then((res)=>{
      }).catch((err) => {})
    },
    createNewBucketBeforeSubmitMethod(){
      this.$validator.validateAll().then((result) => {
        if(result){
          this.submitted =  true
          let data = {
            name:this.name,
            is_folder:true
          }
          this.$store.dispatch('createBucketOfAwerackDetailsFun', data)
            .then((res) => {  
              this.$validator.reset()
              toast.success(res.data.msg);
              this.getBucketListAgainMethod()
              this.closeCreateNewBucketPopup()
              this.submitted =  false
            }).catch((err) => {
              this.submitted =  false
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      })
    },
    closeCreateNewBucketPopup(){
      bus.$emit('newBucketFolderPopupStateBus', false);
      $('body').removeClass('body_right_scroll_remove')
    }
  }
}


